module.exports = __webpack_public_path__ + "img/grid-srp-preview-ford.3332fb59.png";